// extracted by mini-css-extract-plugin
export default {"headerLogoLink":"Header_headerLogoLink__YgJw2","logo":"Header_logo__dK4Pw"};